//
// MapProjection.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/GTLModel";

var MapProjection = createModule("gtl::MapProjection", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        yColumnName: 7,
        proj4Description: 7,
        xColumnName: 7,
        spatialReferenceCode: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default MapProjection;
